import { render } from "./RemoveButton.vue?vue&type=template&id=42be102b"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__